import { render, staticRenderFns } from "./DishReview.vue?vue&type=template&id=8fe74028&"
import script from "./DishReview.vue?vue&type=script&lang=js&"
export * from "./DishReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports